import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getMyAppointmentsRequest: null,
  getMyAppointmentsSuccess: ["appointments"],
  getMyAppointmentsFailure: null,
});

export const GetMyAppointmentsTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetching: null,
  success: null,
  appointments: null,
  error: null,
});

export const GetMyAppointmentsSelectors = {
  getData: (state: any) => state.getMyAppointments.data,
  isFetching: (state: any) => state.getMyAppointments.fetching,
  isSuccess: (state: any) => state.getMyAppointments.success,
  hasError: (state: any) => state.getMyAppointments.error,
};

export const request = (state: any, action: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    appointments: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { appointments } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    appointments,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    appointments: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_MY_APPOINTMENTS_REQUEST]: request,
  [Types.GET_MY_APPOINTMENTS_SUCCESS]: success,
  [Types.GET_MY_APPOINTMENTS_FAILURE]: failure,
});
